<template>
  <div class="bmui-cell_text">
    <p class="bmui-cell_text-title">{{ title || 'TITLE' }}<span v-show="isNeed" class="bmui-cell_text-isNeed">*</span></p>
    <div
      class="bmui-cell_text-content"
      v-if="$slots.default"><slot /></div>
    <p
      class="bmui-cell_text-content"
      v-else>{{ content }}</p>
  </div>
</template>
<script>
export default {
  name: 'BmuiCellText',
  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    isNeed: {
      type: Boolean,
      default: false
    }
  }
}
</script>
